import type { Etat, Urgence } from '@its/shared';

/**
 * AFFICHAGE DES DEMANDES — couleurs et dates.
 *
 * La couleur ne porte jamais seule l'information (ENF-46) : chaque badge garde
 * son libellé. Les libellés eux-mêmes viennent de @its/shared.
 */
export const VARIANTE_URGENCE: Record<Urgence, string> = {
  faible: 'success',
  modere: 'warning',
  bloquant: 'error',
};

export const VARIANTE_ETAT: Record<Etat, string> = {
  emise: 'info',
  prise_en_charge: 'navy',
  attente_demandeur: 'warning',
  gelee: 'neutral',
  cloturee: 'success',
};

const rtf = new Intl.RelativeTimeFormat('fr', { numeric: 'auto' });

/** « il y a 3 heures », « hier » — l'ancienneté se lit d'un coup d'œil. */
export function depuis(iso: string): string {
  const s = (new Date(iso).getTime() - Date.now()) / 1000;
  const a = Math.abs(s);
  if (a < 60) return 'à l’instant';
  if (a < 3600) return rtf.format(Math.round(s / 60), 'minute');
  if (a < 86400) return rtf.format(Math.round(s / 3600), 'hour');
  if (a < 86400 * 30) return rtf.format(Math.round(s / 86400), 'day');
  return dateCourte(iso);
}

export function dateCourte(iso: string): string {
  return new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function dateHeure(iso: string): string {
  return new Date(iso).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' });
}

/**
 * Le nom d'un dossier, sa forme juridique et son numéro : deux dossiers portent
 * parfois le même nom (« La Jeulinière », une par forme juridique) — la forme
 * et le numéro départagent. La forme n'est pas répétée quand la raison
 * sociale la porte déjà (« GARAGE DURAND SARL »).
 */
export function nomClient(s: { nom: string; formeJuridique?: string | null }): string {
  const f = s.formeJuridique?.trim();
  if (!f || s.nom.toUpperCase().split(/[\s,()]+/).includes(f.toUpperCase())) return s.nom;
  return `${s.nom} ${f}`;
}

export function nomDossier(s: { nom: string; numero: string | null; formeJuridique?: string | null } | null): string {
  if (!s) return '—';
  return s.numero ? `${nomClient(s)} (${s.numero})` : nomClient(s);
}
